import React, { useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button,Alert } from '@mui/material/';
import axios from 'axios';
import Cookies from 'js-cookie'

import { useSelector ,useDispatch} from 'react-redux'
import {  useNavigate  } from "react-router-dom";
import { getIsAdmin,getUserRule,getSessionExpirer } from '../../utils/userRule';

import Autorize from '../../components/ui/autorize';
import LstClubsSecteur from '../../components/clubs/lst_clubs_secteur';


//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function ClubsSecteur() {

    const [listSecteur, setListSecteur] = useState("");
    const [ListClubSecteur, setListClubSecteur] = useState("");
    const [errorAxios, setErrorAxios] = useState("false");
    const [autorize, setAutorize] = useState("false");
    const [Search,setSearch] = useState("");  
    const [searchTMP,setSearchTMP] = useState("");         
  
    /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
    const MyAxios = axios.create({    
        headers: { Authorization: "Bearer "+ Cookies.get('token'),
                }      
  })
    

    useEffect(() => { 
           
        if(autorize)
        if(listSecteur === "" )
        {          
            //, { headers: { Authorization: "Bearer "+ cookies }}
            MyAxios.get(process.env.REACT_APP_API + '/clubs/getallsecteur') //axios.defaults.withCredentials = true
            .then((res) => {      
                setErrorAxios(false);
                console.log(res);
                setListSecteur(res.data);
               
            })
            .catch((error) => {
                console.log(error)  
              ///  if(error.status)  
               if(error.response.status === 401)// pas autorisé
                  setErrorAxios(true);   

            });

        }
    },[autorize]);
   

    const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
      };
        

      
    function Recherche()    
    {
        setSearch(searchTMP);
        
    }
      
    function handleChange(event) {
        const value = event.target.value;     
        setSearchTMP(value);   
    }





//  {JSON.stringify(this.state.currentMember, null, 2) }     {Table}
        return (
                  <div style={{ padding:'20px' }}>
                     <Autorize key="clubSecteur1" axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>
                     
                     <Grid container direction="row"  sx={{padding:"10px"}} >
                        <Grid item xs={3} container  > 
                                <TextField id="Search" value={searchTMP} onChange={handleChange} label="Recherche par numéro de club"  style={{ marginLeft: '10px',width:'400px' }}  />
                                <Button variant="containedFifth" sx={{marginLeft:'20px'}} onClick={Recherche} >Rechercher</Button>
                        </Grid> 
                                                  
                    </Grid> 


                        {Object.entries(listSecteur).map(([key, value]) => (
                            <Grid container spacing={2}  sx={{paddingLeft:'20px' }}>                           
                                <Grid item xs={8}> 
                                    <Alert key={"Alert"+value.Default_DistrictNbr} icon={false} severity="info">Secteur { value.Default_DistrictNbr }</Alert>
                                </Grid>
                                <Grid item xs={12}> 
                                    <LstClubsSecteur key={value.Default_DistrictNbr} secteur={value.Default_DistrictNbr} search={Search}/>
                                </Grid>
                            </Grid>                     
                        ))}

                
                </div>
        );
   
};

export default ClubsSecteur;